export default __webpack_public_path__ + "static/media/doctor_chat.72c10471.png";